



































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditFloor from "./edit-floor.vue";
import CreateFloor from "./create-floor.vue";
import Auth from '../../../lib/Judgeauthority';
class PageFloorRequest extends PageRequest {
  FilterText: string;
  ftId:Number;
}
@Component({
  components: { EditFloor, CreateFloor },
})
export default class Floors extends AbpBase {
  pagerequest: PageFloorRequest = new PageFloorRequest();
  publicpagerequest: PageFloorRequest = new PageFloorRequest();
  createModalShow: boolean = false;
  editModalShow: boolean = false;
  searchInt:number = 0;
  showAddButton = false;
  selwarehouselist = [];
  get list() {
    return this.$store.state.floor.list;
  }
  get loading() {
    return this.$store.state.floor.loading;
  }
  pageChange(page: number) {
    this.$store.commit("floor/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("floor/setPageSize", pagesize);
    this.getpage();
  }
  getsearch(){
    this.searchInt = 1;
    this.getpage();
  }
  get factory() {
    return this.$store.state.factory.list;
  }
  get warehouse() {
    return this.$store.state.warehouse.list;
  }
  selfactory(value:Number){
    this.publicpagerequest.ftId = value;
    if(value != 0 && value != undefined){
      this.getselwarehouse();
    }
    else
    {
      this.selwarehouselist = [];
    }
    //this.getwarehouse();
      this.searchInt = 1;
       this.getpage();
  }
  selwarehouse(value:Number){
    this.searchInt = 1;
       this.getpage();
  }
  async getpage() {
    if(this.searchInt == 1){
      this.$store.state.thequipment.currentPage=1;
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = 0;
      this.searchInt = 0;
    }
    else
    {
      this.pagerequest.maxResultCount = this.pageSize;
      this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    }
    //filters
    await this.$store.dispatch({
      type: "floor/getPaged",
      data: this.pagerequest,
    });
  }

  edit() {
    this.editModalShow = true;
  }
  create() {
    this.createModalShow = true;
  }
  get pageSize() {
    return this.$store.state.floor.pageSize;
  }
  get totalCount() {
    return this.$store.state.floor.totalCount;
  }
  get currentPage() {
    return this.$store.state.floor.currentPage;
  }
   userName() {
    //console.log(this.$store.state.session.user);
    return this.$store.state.session.user
      ? this.$store.state.session.user.name
      : "";
  }
    companylist() {
     
    return this.$store.state.company.list;
  }
  columns = [
    {
      title: "所属公司",
      key: "cId",
      render: (h, params) => {
        let cId = params.row.cId;
        let clist = this.companylist();
        for (let entry of clist) {
          //console.log(entry.id); // 1, "string", false
          if(cId==entry.id){
            cId=entry.cName;
            break;
          }
        }
        if(cId==0){
          cId="";
        }
        return h("span", cId);
      },
    },
    {
      title: "库区名称",
      key: "ftId",
      render: (h, params) => {
        let Id = params.row.ftId;
        let flist = this.factorylist(); 
        for (let entry of flist) {
          if(Id==entry.id){
            Id=entry.fName;
            break;
          }
        }
        return h("span", Id);
      },
    },
    {
      title: "库房名称",
      key: "wId",
      render: (h, params) => {
        let Id = params.row.wId;
        let flist = this.warehouselist(); 
        for (let entry of flist) {
          if(Id==entry.id){
            Id=entry.wName;
            break;
          }
        }
        return h("span", Id);
      },
    },
    {
      title: "楼层名称",
      key: "fName",
    },
    {
      title: "楼层编号",
      key: "number",
    },
    {
      title: "状态",
      key: "status",
      render: (h, params) => {
        let status = params.row.status;
        if (status == 1) {
          status = "启用";
        } else if (status == 0) {
          status = "停用";
        }
        return h("span", status);
      },
    },
    {
      title: "操作",
      key: "Actions",
      width: 150,
      render: (h: any, params: any) => {
         let strupdate = h(
            "Button",
            {
              props: {
                type: "primary",
                size: "small",
              },
              style: {
                marginRight: "5px",
              },
              on: {
                click: () => {
                  //console.log(params.row);
                  this.$store.commit("floor/edit", params.row);
                  this.edit();
                },
              },
            },
            this.L("Edit")
          );
          //判断是否有修改权限
        if (!Auth.getauthority("Pages.Floors_Update")) {
          strupdate = null;
        }
         let strdelete = h(
            "Button",
            {
              props: {
                type: "error",
                size: "small",
              },
              on: {
                click: async () => {
                  this.$Modal.confirm({
                    title: "提示",
                    content: "确认删除该条数据？",
                    okText: "删除",
                    cancelText: "取消",
                    onOk: async () => {
                      await this.$store.dispatch({
                        type: "floor/delete",
                        data: params.row,
                      });
                      await this.getpage();
                    },
                  });
                },
              },
            },
            "删除"
          );
          //判断是否有删除权限
        if (!Auth.getauthority("Pages.Floors_Delete")) {
          strdelete = null;
        }
        return h("div", [strupdate, strdelete]);
        
      },
    },
  ];
  ///根据权限返回列数据
  get filterColumns() {
    if (
      !Auth.getauthority("Pages.Floors_Update") &&
      !Auth.getauthority("Pages.Floors_Delete")
    ) {
      return this.columns.filter((col) => col.key !== "Actions");
    }
    return this.columns;
  }
    factorylist(){
      return this.$store.state.factory.list;
    }
    warehouselist(){
      return this.$store.state.warehouse.list;
    }
   async getcompany() {
    this.publicpagerequest.maxResultCount = 99;
    this.publicpagerequest.skipCount = 0;
    //filters
    await this.$store.dispatch({
      type: "company/getAll",
      data: this.publicpagerequest,
    });
  }
  async getfactory(){
      //库区
    //filters
    await this.$store.dispatch({
      type: "factory/getPaged",
      //-
      data: this.publicpagerequest,
    });
  }
  async getwarehouse() {
    //库房
    //filters
    await this.$store.dispatch({
      type: "warehouse/getAll",
      //-
      data: this.publicpagerequest,
    });
  }
    async getselwarehouse(){
    this.selwarehouselist = await this.$store.dispatch({
      type: "warehouse/RegetAll",
      data: this.publicpagerequest,
    });
  }
  created() {
    if (this.userName() !== "admin") {
      this.getfactory();
      this.getwarehouse();
      //不符合权限的，你就没有操作这个列名！！！
      this.columns = this.columns.filter((col) => col.title !== "所属公司");
    }else{
      this.getcompany();
    }
    this.getpage();
    if (Auth.getauthority("Pages.Floors_Create")) {
      this.showAddButton = true;
    }
  }
}
